import { useState, useEffect } from 'react';
import { Router } from '@reach/router';
import { AppPath } from 'appConstants';
import { Dashboard } from 'pages/dashboard/Dashboard';
import { NewSubscription } from 'pages/newSubscription/NewSubscription';
import { Profile } from 'pages/profile/Profile';
import { ManageUsers } from 'pages/manageUsers/ManageUsers';
import { ManageSchool } from 'pages/manageSchool/ManageSchool';
import { Invoices } from 'pages/invoices/Invoices';
import { SignIn } from 'pages/SignIn';
import { ForgottenPassword } from 'pages/ForgottenPassword';
import { ResetPassword } from 'pages/ResetPassword';
import { Subscribe } from 'pages/subscribe/Subscribe';
import { MyDocuments } from 'pages/myDocuments/MyDocuments';
import { useDispatch, useSelector } from 'react-redux';
import { checkSignedIn, selectAppVisible } from 'reducers/auth';
import { selectAccessibilityMode } from 'reducers/misc';
import Toast from 'components/toast/Toast';
import ErrorToast from 'components/toast/ErrorToast';
import InvoicePage from 'pages/invoices/InvoicePage';
import UpgradeFreeSubscriptions from 'pages/upgradeSubscription/UpgradeFreeSubscriptions';
import SubscribeFreeTrial from 'pages/subscribeFreeTrial/SubscribeFreeTrial';
import { SetPassword } from 'pages/SetPassword';
import NotFound from 'pages/NotFound';
import ErrorBoundary from 'components/errorBoundary/ErrorBoundary';
import ErrorFallback from 'components/errorFallback/ErrorFallback';
import AddFreeTrial from 'pages/addFreeTrial/AddFreeTrial';
import MembershipOptions from 'pages/membershipOptions/MembershipOptions';
import { BlockCopyandPaste } from 'helpers/blockCopyandPaste';
//import { cookieSettingHandler } from 'helpers/cookieSettingsHandler';
import CookieBanner from './components/shared/CookieBanner';
import MfaChallengePage from 'pages/mfa/MfaChallengePage';
import MfaChallengeModal from 'components/mfaChallenge/MfaChallengeModal';
import Cookies from 'universal-cookie';
import { selectHideCookieBanner } from 'reducers/misc';
import LessonUnit from 'pages/lessons/LessonUnit';
import LessonSchemeOfWork from 'pages/lessons/LessonSchemeOfWork';
import LessonPlanPage from 'pages/lessons/LessonPlanPage';
import LessonPresentation from 'pages/lessons/LessonPresentation';
import ResourceBankHome from 'pages/resources/ResourceBankHome';
import AwesomeStuff from 'pages/resources/AwesomeStuff';
import ResourcesByActivity from 'pages/resources/ResourcesByActivity';
import ResourceCategoryPage from 'pages/resources/ResourceCategoryPage';
import ResourceActivityPage from 'pages/resources/ResourceActivityPage';
import ResourcePresentation from 'pages/resources/ResourcePresentation';
import ResourcePlayer from 'pages/resources/ResourcePlayer';
import ResourceSearch from 'pages/resources/ResourceSearch';

const App = () => {
  const dispatch = useDispatch();
  const accessibilityMode = useSelector(selectAccessibilityMode);
  const hideCookieBanner: boolean = useSelector(selectHideCookieBanner);

  const [cookieSettingsSelection, setCookieSettingsSelection] = useState<string>('');
  const [isIFrame, setIsIFrame] = useState<boolean>(inIframe());

  dispatch(checkSignedIn());
  const showApp = useSelector(selectAppVisible);

  useEffect(() => {
    BlockCopyandPaste();
  }, []);

  useEffect(() => {
    let cookieSettingFlag = new Cookies();
    setCookieSettingsSelection(cookieSettingFlag.get('cookie_settings') ? cookieSettingFlag.get('cookie_settings') : "");
  }, []);

  useEffect(() => {
    if(window.self !== window.top){
      document.getElementById("EducationPortal")?.classList.add("InIFrame");
    }
  }, []); 
  
  
  function inIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
  } 


  if (!showApp) {
    return null;
  }

  return (
    <ErrorBoundary fallback={<ErrorFallback />}>
      <div className={'App' + (accessibilityMode ? ' accessible' : '')}>
        <Toast />
        <ErrorToast />
        <MfaChallengeModal />
        <Router>
          {[AppPath.SIGN_IN, AppPath.ROOT].map((path: string, i: number) => (
            <SignIn path={path} key={i} />
          ))}
          <SignIn path={AppPath.SIGN_IN} />
          <ForgottenPassword path={AppPath.FORGOTTEN_PASSWORD} />
          <ResetPassword path={AppPath.RESET_PASSWORD} />
          <SetPassword path={AppPath.SET_PASSWORD} />
          <Subscribe path={AppPath.SUBSCRIBE} />
          <SubscribeFreeTrial path={AppPath.SUBSCRIBE_FREE_TRIAL} />
          <Dashboard path={AppPath.DASHBOARD} />
          <NewSubscription path={AppPath.NEW_SUBSCRIPTION} />
          <AddFreeTrial path={AppPath.NEW_FREE_TRIAL} />
          <MembershipOptions path={AppPath.MEMBERSHIP_OPTIONS} />
          <MyDocuments path={AppPath.MY_DOCUMENTS} />
          <UpgradeFreeSubscriptions path={AppPath.UPGRADE_SUBSCRIPTION} />
          <Profile path={AppPath.PROFILE} />
          <ManageUsers path={AppPath.MANAGEUSERS} />
          <ManageSchool path={AppPath.MANAGESCHOOL} />
          <Invoices path={AppPath.INVOICES} />
          <InvoicePage path={AppPath.INVOICE_PAGE} />
          <MfaChallengePage path={AppPath.MFA_CHALLENGE} />
          <LessonUnit path={AppPath.LESSON_UNIT} />
          <LessonSchemeOfWork path={AppPath.LESSON_SCHEME_OF_WORK} />
          <LessonPlanPage path={AppPath.LESSON_PLAN} />
          <LessonPresentation path={AppPath.LESSON_PRESENTATION} />
          <ResourceBankHome path={AppPath.RESOURCE_BANK} />
          <AwesomeStuff path={AppPath.RESOURCE_AWESOME_STUFF} />
          <ResourcesByActivity path={AppPath.RESOURCES_BY_ACTIVITY} />
          <ResourceCategoryPage path={AppPath.RESOURCE_CATEGORY} />
          <ResourceCategoryPage path={AppPath.RESOURCE_CATEGORY_TYPE} />
          <ResourceActivityPage path={AppPath.RESOURCE_ACTIVITY} bIsGroup={false} />
          <ResourceActivityPage path={AppPath.RESOURCE_ACTIVITY_TYPE} bIsGroup={false} />
          <ResourceActivityPage path={AppPath.RESOURCE_ACTIVITY_GROUP} bIsGroup />
          <ResourceActivityPage path={AppPath.RESOURCE_ACTIVITY_GROUP_TYPE} bIsGroup />
          <ResourcePresentation path={AppPath.RESOURCE_PRESENTATION} />
          <ResourcePlayer path={AppPath.RESOURCE_FILE} />
          <ResourceSearch path={AppPath.RESOURCE_SEARCH} />
          <NotFound default />
        </Router>
        {!cookieSettingsSelection && !hideCookieBanner && <CookieBanner />}
      </div>
    </ErrorBoundary>
  );
};

export default App;
